// import React from 'react';
// import { Helmet } from 'react-helmet-async';
// import { useLocation } from 'react-router-dom';
// import { useTranslation } from 'react-i18next';

// const SEO = ({
//   title,
//   description,
//   keywords,
//   image,
//   url,
//   type = 'website',

//   publishedTime,
//   modifiedTime,
//   author,
//   section,
//   tags,

//   noIndex = false,
//   noFollow = false,
//   canonicalUrl,

//   children
// }) => {
//   const location = useLocation();
//   const { i18n } = useTranslation();
//   const currentLang = i18n.language;

//   const siteUrl = process.env.REACT_APP_SITE_URL || 'https://carabinex.com';
//   const currentUrl = url || `${siteUrl}${location.pathname}`;
//   const defaultImage = 'https://carabinex.onrender.com/images/og-default.jpg';
//   const finalImage = image || defaultImage;

//   const finalTitle = title
//     ? title.includes('Carabinex') ? title : `${title} | Carabinex`
//     : 'Carabinex';

//   const finalDescription = description || 'Strategy, creativity and technology come together to create solutions that help businesses attract customers and grow with confidence.';

//   const robotsContent = `${noIndex ? 'noindex' : 'index'}, ${noFollow ? 'nofollow' : 'follow'}`;

//   const languages = {
//     ua: 'uk_UA',
//     en: 'en_US',
//     ru: 'ru_RU',
//     pl: 'pl_PL',
//     de: 'de_DE',
//     es: 'es_ES'
//   };
//   const currentOgLocale = languages[currentLang] || 'uk_UA';

//   const generateJsonLd = () => {
//     const baseUrl = siteUrl;

//     if (type === 'article') {
//       return {
//         "@context": "https://schema.org",
//         "@type": "Article",
//         "headline": finalTitle,
//         "description": finalDescription,
//         "image": finalImage,
//         "datePublished": publishedTime || new Date().toISOString().split('T')[0],
//         "author": {
//           "@type": "Person",
//           "name": author || "Carabinex Team"
//         },
//         "publisher": {
//           "@type": "Organization",
//           "name": "Carabinex"
//         }
//       };
//     }

//     if (type === 'product') {
//       return {
//         "@context": "https://schema.org",
//         "@type": "CreativeWork",
//         "name": finalTitle,
//         "description": finalDescription,
//         "image": finalImage
//       };
//     }

//     if (type === 'website') {
//       return {
//         "@context": "https://schema.org",
//         "@type": "Organization",
//         "name": "Carabinex",
//         "url": baseUrl,
//         "description": finalDescription
//       };
//     }

//     return null;
//   };

//   const jsonLd = generateJsonLd();

//   const organizationJsonLd = {
//     "@context": "https://schema.org",
//     "@type": "Organization",
//     "image": "https://carabinex.com/images/logo_small.jpg",
//     "url": "https://carabinex.com",
//     "logo": "https://carabinex.com/images/logo_small.png",
//     "name": "Carabinex"
//   };

//   const getPathWithoutLang = (pathname) => {
//     const langs = ['ua', 'en', 'ru', 'pl', 'de', 'es'];
//     const pathParts = pathname.split('/').filter(Boolean);
//     if (langs.includes(pathParts[0])) {
//       const clean = '/' + pathParts.slice(1).join('/');
//       return clean === '/' ? '' : clean;
//     }
//     return pathname;
//   };

//   const cleanPath = getPathWithoutLang(location.pathname);

//   return (
//     <Helmet>
//       <title>{finalTitle}</title>
//       <meta name="description" content={finalDescription} />
//       {keywords && <meta name="keywords" content={keywords} />}
//       <meta name="robots" content={robotsContent} />

//       <link rel="canonical" href={canonicalUrl || currentUrl} />

//       {/* <link rel="alternate" hrefLang="uk" href={`${siteUrl}/ua${location.pathname}`} />
//       <link rel="alternate" hrefLang="en" href={`${siteUrl}/en${location.pathname}`} />
//       <link rel="alternate" hrefLang="ru" href={`${siteUrl}/ru${location.pathname}`} />
//       <link rel="alternate" hrefLang="pl" href={`${siteUrl}/pl${location.pathname}`} />
//       <link rel="alternate" hrefLang="de" href={`${siteUrl}/de${location.pathname}`} />
//       <link rel="alternate" hrefLang="es" href={`${siteUrl}/es${location.pathname}`} />
//       <link rel="alternate" hrefLang="x-default" href={`${siteUrl}/ua${location.pathname}`} /> */}

//       <link rel="alternate" hrefLang="uk" href={`${siteUrl}/ua${cleanPath}`} />
//       <link rel="alternate" hrefLang="en" href={`${siteUrl}/en${cleanPath}`} />
//       <link rel="alternate" hrefLang="ru" href={`${siteUrl}/ru${cleanPath}`} />
//       <link rel="alternate" hrefLang="pl" href={`${siteUrl}/pl${cleanPath}`} />
//       <link rel="alternate" hrefLang="de" href={`${siteUrl}/de${cleanPath}`} />
//       <link rel="alternate" hrefLang="es" href={`${siteUrl}/es${cleanPath}`} />
//       <link rel="alternate" hrefLang="x-default" href={`${siteUrl}/ua${cleanPath}`} />

//       <meta property="og:title" content={finalTitle} />
//       <meta property="og:description" content={finalDescription} />
//       <meta property="og:image" content={finalImage} />
//       <meta property="og:image:width" content="1200" />
//       <meta property="og:image:height" content="630" />
//       <meta property="og:url" content={currentUrl} />
//       <meta property="og:type" content={type} />
//       <meta property="og:site_name" content="Carabinex" />
//       <meta property="og:locale" content={currentOgLocale} />
//       <meta property="og:locale:alternate" content="uk_UA" />
//       <meta property="og:locale:alternate" content="en_US" />
//       <meta property="og:locale:alternate" content="ru_RU" />
//       <meta property="og:locale:alternate" content="pl_PL" />
//       <meta property="og:locale:alternate" content="de_DE" />
//       <meta property="og:locale:alternate" content="es_ES" />

//       {type === 'article' && (
//         <>
//           {publishedTime && <meta property="article:published_time" content={publishedTime} />}
//           {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
//           <meta property="article:author" content={author || 'Carabinex Team'} />
//           {section && <meta property="article:section" content={section} />}
//           {tags && tags.map((tag, i) => (
//             <meta key={i} property="article:tag" content={tag} />
//           ))}
//         </>
//       )}

//       {jsonLd && (
//         <script type="application/ld+json">
//           {JSON.stringify(jsonLd)}
//         </script>
//       )}

//       <script type="application/ld+json">
//         {JSON.stringify(organizationJsonLd)}
//       </script>

//       <meta name="format-detection" content="telephone=no" />
//       <meta name="theme-color" content="#1733be" />
//       <meta name="viewport" content="width=device-width, initial-scale=1.0" />

//       {children}
//     </Helmet>
//   );
// };

// export default React.memo(SEO);






import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SEO = ({
  title,
  description,
  keywords,
  image,
  url,
  type = 'website',

  publishedTime,
  modifiedTime,
  author,
  section,
  tags,

  noIndex = false,
  noFollow = false,
  canonicalUrl,

  children
}) => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const siteUrl = process.env.REACT_APP_SITE_URL || 'https://carabinex.com';
  const currentUrl = url || `${siteUrl}${location.pathname}`;
  const defaultImage = 'https://carabinex.onrender.com/images/og-default.jpg';
  const finalImage = image || defaultImage;

  const finalTitle = title
    ? title.includes('Carabinex') ? title : `${title} | Carabinex`
    : 'Carabinex';

  const finalDescription = description || 'Strategy, creativity and technology come together to create solutions that help businesses attract customers and grow with confidence.';

  const robotsContent = `${noIndex ? 'noindex' : 'index'}, ${noFollow ? 'nofollow' : 'follow'}`;

  // === ЗАЩИТА ОТ ДВОЙНЫХ ЯЗЫКОВЫХ ПРЕФИКСОВ ===
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const langs = ['ua', 'en', 'ru', 'pl', 'de', 'es'];
  
  // Если первый и второй сегмент оба являются языковыми кодами → noindex
  const hasDuplicateLang = pathSegments.length > 1 && 
    langs.includes(pathSegments[0]) && 
    langs.includes(pathSegments[1]);
  
  // Если путь содержит более 10 сегментов → noindex (атака)
  const isTooDeep = pathSegments.length > 10;
  
  // Если в пути есть повторяющиеся языковые коды подряд (ru/ru, pl/pl и т.д.)
  let hasInvalidPattern = false;
  for (let i = 0; i < pathSegments.length - 1; i++) {
    if (langs.includes(pathSegments[i]) && pathSegments[i] === pathSegments[i+1]) {
      hasInvalidPattern = true;
      break;
    }
  }
  
  const shouldNoIndex = hasDuplicateLang || isTooDeep || hasInvalidPattern;
  const finalRobots = shouldNoIndex ? 'noindex, follow' : robotsContent;

  const languages = {
    ua: 'uk_UA',
    en: 'en_US',
    ru: 'ru_RU',
    pl: 'pl_PL',
    de: 'de_DE',
    es: 'es_ES'
  };
  const currentOgLocale = languages[currentLang] || 'uk_UA';

  const generateJsonLd = () => {
    const baseUrl = siteUrl;

    if (type === 'article') {
      return {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": finalTitle,
        "description": finalDescription,
        "image": finalImage,
        "datePublished": publishedTime || new Date().toISOString().split('T')[0],
        "author": {
          "@type": "Person",
          "name": author || "Carabinex Team"
        },
        "publisher": {
          "@type": "Organization",
          "name": "Carabinex"
        }
      };
    }

    if (type === 'product') {
      return {
        "@context": "https://schema.org",
        "@type": "CreativeWork",
        "name": finalTitle,
        "description": finalDescription,
        "image": finalImage
      };
    }

    if (type === 'website') {
      return {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Carabinex",
        "url": baseUrl,
        "description": finalDescription
      };
    }

    return null;
  };

  const jsonLd = generateJsonLd();

  const organizationJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "image": "https://carabinex.com/images/logo_small.jpg",
    "url": "https://carabinex.com",
    "logo": "https://carabinex.com/images/logo_small.png",
    "name": "Carabinex"
  };

  const getPathWithoutLang = (pathname) => {
    const langs = ['ua', 'en', 'ru', 'pl', 'de', 'es'];
    const pathParts = pathname.split('/').filter(Boolean);
    if (langs.includes(pathParts[0])) {
      const clean = '/' + pathParts.slice(1).join('/');
      return clean === '/' ? '' : clean;
    }
    return pathname;
  };

  const cleanPath = getPathWithoutLang(location.pathname);

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={finalRobots} />

      <link rel="canonical" href={canonicalUrl || currentUrl} />

      <link rel="alternate" hrefLang="uk" href={`${siteUrl}/ua${cleanPath}`} />
      <link rel="alternate" hrefLang="en" href={`${siteUrl}/en${cleanPath}`} />
      <link rel="alternate" hrefLang="ru" href={`${siteUrl}/ru${cleanPath}`} />
      <link rel="alternate" hrefLang="pl" href={`${siteUrl}/pl${cleanPath}`} />
      <link rel="alternate" hrefLang="de" href={`${siteUrl}/de${cleanPath}`} />
      <link rel="alternate" hrefLang="es" href={`${siteUrl}/es${cleanPath}`} />
      <link rel="alternate" hrefLang="x-default" href={`${siteUrl}/ua${cleanPath}`} />

      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Carabinex" />
      <meta property="og:locale" content={currentOgLocale} />
      <meta property="og:locale:alternate" content="uk_UA" />
      <meta property="og:locale:alternate" content="en_US" />
      <meta property="og:locale:alternate" content="ru_RU" />
      <meta property="og:locale:alternate" content="pl_PL" />
      <meta property="og:locale:alternate" content="de_DE" />
      <meta property="og:locale:alternate" content="es_ES" />

      {type === 'article' && (
        <>
          {publishedTime && <meta property="article:published_time" content={publishedTime} />}
          {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
          <meta property="article:author" content={author || 'Carabinex Team'} />
          {section && <meta property="article:section" content={section} />}
          {tags && tags.map((tag, i) => (
            <meta key={i} property="article:tag" content={tag} />
          ))}
        </>
      )}

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}

      <script type="application/ld+json">
        {JSON.stringify(organizationJsonLd)}
      </script>

      <meta name="format-detection" content="telephone=no" />
      <meta name="theme-color" content="#1733be" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      {children}
    </Helmet>
  );
};

export default React.memo(SEO);